import { page as PagesNotFound } from "./pages/[...notFound].js";
import { page as PagesAbout } from "./pages/about.js";
import { page as PagesArticlesSlug } from "./pages/articles/[slug].js";
import { page as PagesIndex } from "./pages/index.js";
import { page as PagesIssuesSlug } from "./pages/issues/[slug].js";
import { page as PagesIssuesIndex } from "./pages/issues/index.js";
import { layout as PagesLayout } from "./pages/layout.js";

export const routes = [
	{ path: "/*", element: PagesNotFound, auth: false },
	{ path: "/about", element: PagesAbout, auth: false },
	{ path: "/articles/:slug", element: PagesArticlesSlug, auth: false },
	{ path: "/", element: PagesIndex, auth: false },
	{ path: "/issues/:slug", element: PagesIssuesSlug, auth: false },
	{ path: "/issues", element: PagesIssuesIndex, auth: false },
];

export const layouts = {
	"/": PagesLayout,
};
